import type { FC } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  useEditAction,
  useBoostAction,
  useSellAction,
} from '../../tableActions/hooks/useTableActionsRegistry';

import s from './PublishedActionsMobile.scss';

interface Props {
  deviation: PapiDeviation;
}
const PublishedActionsMobile: FC<Props> = ({ deviation }) => {
  const { renderButton: renderEditButton } = useEditAction(deviation);
  const { renderButton: renderBoostButton } = useBoostAction(deviation) ?? {};
  const { renderButton: renderSellButton } = useSellAction(deviation) ?? {};

  return (
    <div className={s['root']}>
      {renderBoostButton && renderBoostButton(false)}
      {renderEditButton && renderEditButton(false)}
      {renderSellButton && renderSellButton(false)}
    </div>
  );
};
PublishedActionsMobile.displayName = 'PublishedActionsMobile';

export default PublishedActionsMobile;
